/** Actions */
import axios from "axios";

export { store } from "./store";
export { httpRequestsOnSuccessActions } from "./http_requests_on_success";
export { httpRequestsOnErrorsActions } from "./http_requests_on_errors";
export { httpRequestsOnLoadActions } from "./http_requests_on_load";

export { authActions } from "./auth";
export { usersActions } from "./users";
export { employeesActions } from "./employees";
export { facilitiesActions } from "./facilities";
export { payerActions } from "./payer";
export { patientsActions } from "./patients";
export { avatarActions } from "./avatar";
export { vehiclesActions } from "./vehicles";
export { legsActions } from "./legs";
export { noteActions } from "./notes";
export { historyActions } from "./history";

export const UploadServices = {
  UploadImage: (formData) =>
    axios.post("/files/upload?includeThumbnail=false", formData, {
      auth: true,
      params: "",
    }),

  UploadImageThumb: (formData) =>
    axios.post("/files/upload?includeThumbnail=true", formData, {
      auth: true,
      params: "",
    }),
};
